module.exports = __webpack_public_path__ + "static/media/customDesignStep3Mobile.fb8f64cd.PNG";